import { useCallback, useEffect } from 'react';
import { isExternalUrl } from '@/utils/url';
import buildUrlUtm from '@/utils/buildUrlUtm';

export function useExternalClickHandler() {
  const handleClick = useCallback((event: MouseEvent) => {
    const origin = (event.target as HTMLElement).closest(
      'a',
    ) as HTMLAnchorElement | null;
    if (origin && isExternalUrl(origin.host)) {
      event.preventDefault();
      event.stopPropagation();

      if (origin.target) {
        return window.open(buildUrlUtm(origin.href), '_blank');
      }

      window.location.href = buildUrlUtm(origin.href);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
}
